import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGptResponse } from '../Store/slices/gpt.slice';
import { v4 as uuidv4 } from 'uuid';

export const useGptResponses = () => {
    const dispatch = useDispatch();
    const [responseId, setResponseId] = useState('');

    const submitPrompt = useCallback((prompt) => {
        const promptId = uuidv4(); // Generate a unique ID for each prompt
        dispatch(fetchGptResponse({ prompt, id: promptId }));
        setResponseId(promptId);  // Update the state with the new response ID
        return promptId;  // Return the ID to be optionally used immediately
    }, [dispatch]);

    return {
        responseId,
        submitPrompt,
    };
};
